import { useEffect, useState } from 'react';
import type { CalDateInfo, SlotInfo } from '../../../types/schedule.types';

export function useOptimisticScheduleData(params: {
  slotList?: SlotInfo[] | null;
  calDates?: CalDateInfo[] | null;
}) {
  const { slotList, calDates } = params;

  const [optimisticCalDates, setOptimisticCalDates] = useState<CalDateInfo[]>(calDates || []);
  const [optimisticSlots, setOptimisticSlots] = useState<SlotInfo[]>(slotList || []);

  useEffect(() => {
    setOptimisticCalDates(calDates || []);
  }, [calDates]);

  useEffect(() => {
    setOptimisticSlots(slotList || []);
  }, [slotList]);

  return {
    optimisticCalDates,
    setOptimisticCalDates,
    optimisticSlots,
    setOptimisticSlots,
  };
}
